<template>
  <v-app>
    <v-main>
      <v-container v-if="page===0">
        <v-row>
          <v-col cols="12">
            <h2>Пожалуйста выберете интересующий раздел</h2>
           
          </v-col>
        </v-row>

      </v-container>

      <v-container v-if="page===2">
        <v-row>
          <v-col cols="12">
            <h2>Введите номер заказ-Наряда или ГосНомер</h2>
           
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
            v-model="numberZN"
            
            label="Номер ЗН"
          
          ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
            v-model="GS"
            
            label="ГосНомер"
          
          ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" @click="fetchDataZN">Поиск</v-btn>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs
                v-model="tab"
                bg-color="primary"
              >
                <v-tab value="rab">Работы</v-tab>
                <v-tab value="tov">Товары</v-tab>
              </v-tabs>
          
              <v-card-text>
                <v-tabs-window v-model="tab">
                  <v-tabs-window-item value="rab">
                    <v-row>
                      <v-col cols="12">
                        <v-data-table-virtual :headers="headersWork" :items="ordersWork">
                          
                        </v-data-table-virtual>
                      </v-col>
                    </v-row>
                  </v-tabs-window-item>
          
                  <v-tabs-window-item value="tov">
                    <v-row>
                    <v-col cols="12">
                      <v-data-table-virtual v-model="selected" :headers="headersT" :items="ordersT">
                        <template v-slot:item.selected="{ item }">
                          <div class="text-end">
                            <v-checkbox
                            v-if="!item.Выдан || item.КоличествоНаСкладе > 0 && !item.Выдан"
                            
                            @change="updateSelection(item)"
                          ></v-checkbox>
                          </div>
                        </template>
                        <template v-slot:item.Выдан="{ item }">
                          <div class="text-start">
                            <v-chip
                              :color="item.Выдан ? 'grey' : item.КоличествоНаСкладе > 0 ? 'green' : 'red'"
                              :text="item.Выдан ? 'Выдан' : item.КоличествоНаСкладе > 0 ? 'На складе' : 'Отсутствует'"
                              class="text-uppercase"
                              size="small"
                              label
                            ></v-chip>
                          </div>
                        </template> 
                      </v-data-table-virtual>
                      <v-btn v-if="selectedItems.length > 0" >Переместить в производство</v-btn>
                    </v-col>
                  </v-row>
                  </v-tabs-window-item>
          
                  
                </v-tabs-window>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <v-container v-if="page===1">
        <v-row>
          <v-col cols="12">
            <h2>Сотрудник: {{ employeeName }}</h2>
            <h3>Общая выработка: {{ totalOutput.toFixed(2) }} ₽</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="is_admin === 1" cols="6">
            <v-select
              v-model="selectedEmployee"
              
              item-title="name"
              item-value="name"
              :items="employees"
              label="Выберите сотрудника"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="selectedMonth"
              item-title="text"
              item-value="value"
              :items="months"
              label="Выберите месяц"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="selectedYear"
              :items="years"
              label="Выберите год"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn color="primary" @click="fetchData">Показать</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table-virtual :headers="headers" :items="orders">
              <template v-slot:item.actions="{ item }">
                <v-btn @click="showDetailsDialog(item)">Детали</v-btn>
              </template>
            </v-data-table-virtual>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Детали работ</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item-group>
                  <v-list-item v-for="work in selectedOrder.works" :key="work.ЗаказНарядНомер">
                    <v-list-item-content>
                      <v-list-item-title>{{ work.АвтоработаНаименование }}</v-list-item-title>
                      <v-list-item-subtitle>Начислено: {{ work.НачисленоОборот }} ₽</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-bottom-navigation grow>
        <v-btn @click="page=2" value="recent">
          <v-icon>mdi-car</v-icon>
      
          <span>Заказ-Наряды</span>
        </v-btn>
      
        <v-btn @click="console.log(page=1)" value="favorites">
          <v-icon>mdi-currency-rub</v-icon>
      
          <span>Выработка</span>
        </v-btn>
      
        
      </v-bottom-navigation>
    </v-main>
  </v-app>
</template>

<script>
import axios from '../axios';
import { ref, onMounted } from 'vue';

export default {
  data() {
    return {
      employeeName: '',
      totalOutput: 0,
      selected: [],
      
      orders: [],
      ordersWork: [],
      headersWork:[
        { title: 'Наименование', value: 'АвтоработаНаименование' }
      ],
      ordersT: [],
      headersT:[
        { title: '№', value: 'selected' },
        { title: 'Статус', value: 'Выдан' },
        { title: 'Наименование', value: 'НоменклатураНаименование' },
        { title: 'Каталожник', value: 'НоменклатураАртикул' },
        { title: 'К-во', value: 'Количество' },
      ],
      headers: [
        { title: 'Авто', value: 'ЗаказНарядНомер' },
        { title: 'Общая сумма', value: 'total' },
        { title: 'Действия', value: 'actions', sortable: false }
      ],
      numberZN:null,
      GS: null,
      tab: null,
      selectedEmployee: null,
      employees: [
  'Гафурова Элина Альбертовна',
  'Гималтдинов Руслан Ринатович',
  'Гиниятуллин Рауль Рамилевич',
  'Гробов Эдуард Александрович',
  'Еникеев Ренат Робертович',
  'Зиганшина Розалия Альбертовна',
  'Иванов Глеб Александрович',
  'Исматов Фархат Бахтиярович',
  'Камаев Эрик Рустамович',
  'Кочкин Михаил Вячеславович',
  'Кутлуюпова Танчулпан Ильдаровна',
  'Маркелов Евгений Анатольевич',
  'Матковский Александр Владимирович',
  'Морозов Матвей Антонович',
  'Неганова Анна Сергеевна',
  'Прудников Владислав Алекандрович',
  'Садриев Ильнур Искандарович',
  'Садриев Ирек Искандарович',
  'Тихонов Вячеслав Александрович',
  'Туембетов Альберт Фаритович',
  'Филенко Виктор Владимирович',
  'Харасов Роман Андреевич',
  'Юнусов Эдуард Раисович',
  'Яковлев Максим Валерьевич',
  'Ялунин Анатолий Александрович'
],
      is_admin: 0,
      dialog: false,
      selectedOrder: {},
      selectedMonth: null,
      page: 0,
      selectedItems: [],
      selectedYear: null,
      months: [
        { text: 'Январь', value: 1 },
        { text: 'Февраль', value: 2 },
        { text: 'Март', value: 3 },
        { text: 'Апрель', value: 4 },
        { text: 'Май', value: 5 },
        { text: 'Июнь', value: 6 },
        { text: 'Июль', value: 7 },
        { text: 'Август', value: 8 },
        { text: 'Сентябрь', value: 9 },
        { text: 'Октябрь', value: 10 },
        { text: 'Ноябрь', value: 11 },
        { text: 'Декабрь', value: 12 }
      ],
      years: Array.from({ length: 10 }, (v, i) => new Date().getFullYear() - i) // Last 10 years
    };
  },
  methods: {

    updateSelection(item) {
      item.selected = !item.selected;
      if (item.selected) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(i => i.НоменклатураАртикул !== item.НоменклатураАртикул);
      }
      console.log(this.selectedItems);
    }, 
    async fetchData() {
      const telegramId = window.Telegram.WebApp.initDataUnsafe.user.id;
      const first_name = window.Telegram.WebApp.initDataUnsafe.user.first_name;
      const username = window.Telegram.WebApp.initDataUnsafe.user.username;
      const startDate = this.selectedMonth && this.selectedYear ? `01.${this.selectedMonth.toString().padStart(2, '0')}.${this.selectedYear}` : null;
      const endDate = this.selectedMonth && this.selectedYear ? `${new Date(this.selectedYear, this.selectedMonth, 0).getDate().toString().padStart(2, '0')}.${this.selectedMonth.toString().padStart(2, '0')}.${this.selectedYear}` : null;
      const em = this.selectedEmployee;
      try {
        const response = await axios.post('getUserInfo', { telegram_id: telegramId, first_name: first_name, username: username });
        this.is_admin = response.data.is_admin;
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      }
      if(this.is_admin === 1){
      try {
        const response = await axios.post('zpp', { telegram_id: telegramId, first_name: first_name, username: username,  start_date: startDate, end_date: endDate, em: em });
        this.processData(response.data);
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      }
    }else{
      try {
        const response = await axios.post('zp', { telegram_id: telegramId, first_name: first_name, username: username, start_date: startDate, end_date: endDate });
        this.processData(response.data);
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      }
    }
    },
    async fetchDataZN() {
      const telegramId = window.Telegram.WebApp.initDataUnsafe.user.id;
      const first_name = window.Telegram.WebApp.initDataUnsafe.user.first_name;
      const username = window.Telegram.WebApp.initDataUnsafe.user.username;
      const gs = this.GS;
      
      
      try {
        const response = await axios.post('znGS', { telegram_id: telegramId, first_name: first_name, username: username, gs: gs});
        console.log(response.data);
        this.ordersWork = response.data[0].АвтоРаботы;
        this.ordersT = response.data[0].Товары;
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      
    }
    },
    processData(data) {
      this.employeeName = data[0].СотрудникНаименование; // Предполагаем, что имя сотрудника одно и то же
      this.totalOutput = data.reduce((sum, item) => sum + item.НачисленоОборот, 0);

      const orderMap = {};
      data.forEach(item => {
        if (!orderMap[item.ЗаказНарядНомер]) {
          orderMap[item.ЗаказНарядНомер] = {
            ЗаказНарядНомер: item.ЗаказНарядНомер,
            Номер: item.Номер,
            Мастер: item.Мастер,
            total: 0,
            works: []
          };
        }
        orderMap[item.ЗаказНарядНомер].total += item.НачисленоОборот;
        orderMap[item.ЗаказНарядНомер].works.push(item);
      });

      this.orders = Object.values(orderMap).map(order => ({
        ...order,
        total: order.total.toFixed(2)
      }));
    },
    showDetailsDialog(order) {
      this.selectedOrder = order;
      this.dialog = true;
    },
    updateDateRange() {
      // This method is no longer needed since we are using the button to fetch data
    }
  },
  mounted() {
    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.expand();
    this.fetchData();
  }
};
</script>

<style scoped>
/* Добавьте стили, если необходимо */
</style> 